module.exports = __webpack_public_path__ + "static/media/IconWoker.cfab08a9.png";